import { html } from 'lit';

type Props = {
  backgroundColor?: string;
  className?: string;
  color?: string;
  size?: number;
  isHidden: boolean;
  onClick: () => void;
};

export const closeButton = ({
  backgroundColor = 'black',
  className,
  color = 'white',
  size = 24,
  isHidden,
  onClick,
}: Props) => html`
  <button
    class="close-button ${className}"
    style="all: unset; display: inline-block; box-sizing: border-box; cursor: pointer; position: inherit; z-index: 2; width: ${size}px; height: ${size}px;"
  >
    <svg
      id="icon"
      aria-hidden=${isHidden}
      width="${size}"
      height="${size}"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style="background-color: ${backgroundColor}; border-radius: 50%"
      @click=${onClick}
    >
      <path
        d="M16.3394 9.32245C16.7434 8.94589 16.7657 8.31312 16.3891 7.90911C16.0126 7.50509 15.3798 7.48283 14.9758 7.85938L12.0497 10.5866L9.32245 7.66048C8.94589 7.25647 8.31312 7.23421 7.90911 7.61076C7.50509 7.98731 7.48283 8.62008 7.85938 9.0241L10.5866 11.9502L7.66048 14.6775C7.25647 15.054 7.23421 15.6868 7.61076 16.0908C7.98731 16.4948 8.62008 16.5171 9.0241 16.1405L11.9502 13.4133L14.6775 16.3394C15.054 16.7434 15.6868 16.7657 16.0908 16.3891C16.4948 16.0126 16.5171 15.3798 16.1405 14.9758L13.4133 12.0497L16.3394 9.32245Z"
        fill=${color}
      />
    </svg>
  </button>
`;
